import React, { useEffect, useRef, useState } from 'react'
import { Dropdown, DropdownItem } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import axios from '../../API/axios';
import ErrorToast from '../ErrorToast';
import WarningToast from '../WarningToast';
import SuccessToast from '../SuccessToast';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import ReportGmailerrorredSharpIcon from '@mui/icons-material/ReportGmailerrorredSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import PersonAddAlt1SharpIcon from '@mui/icons-material/PersonAddAlt1Sharp';
import PersonRemoveAlt1SharpIcon from '@mui/icons-material/PersonRemoveAlt1Sharp';
import PersonAddAltSharpIcon from '@mui/icons-material/PersonAddAltSharp';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import LinkOffSharpIcon from '@mui/icons-material/LinkOffSharp';
import useNewsFeedStore from '../NewsFeed/useNewsFeedStore';
import { useTranslation } from 'react-i18next';
import ModalForGuest from '../ModalForGuest';

const PeopleInteraction = ({searchuserList, item,  userUid, isFollowedByYou, isConnectedByYou, getUserProfileList, index }) => {
    const { t } = useTranslation();
    const guestModeData = localStorage.getItem("guestMode");
    const sessionId = localStorage.getItem("sessionId");
    console.log("itemooooo", item);
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const language = localStorage.getItem("Lang");
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedUserId, setSelectedUserId] = useState(null);

    const checkedUsersRef = useRef({});

    const handleToggleDropdown = (index) => {
        setShowDropdown((prev) => (prev === index ? null : index));
    };
    const handleUnfollowCloseModal = () => {
        setShowModal(false);
        // setSelectedItem(null);
    };
    const handleShowModal = () => {
        // setSelectedItem(item);
        // console.log("unfollow item", item);
        // setSelectedUserId(item.userUid);
        setShowModal(true);
    };
    const [followModal, setFollowModal] = useState(false);
    const closeModalData = () => {
        setFollowModal(false);
    };
    const [showModal, setShowModal] = useState(false);
    const [checkFollow, setCheckFollow] = useState(isFollowedByYou);
    const FollowUser = async (id) => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: id,
            langKey: language === "en" ? "" : language,

        };
        try {
            await axios.post("UserFollow/FollowUser", data).then((resData) => {
                // setFollowedCompanies((prev) => ({ ...prev, [id]: true }));
                setToastMessage(resData.data.message);
                setShowToast(true);
                setCheckFollow(true)
                // getUserProfileList()
                // Optionally, you can update the userList or searchuserList state if needed
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    const unFollowUser = async () => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: userUid,
            langKey: language === "en" ? "" : language,
        };
        try {
            await axios.post(`UserFollow/UnfollowUser`, responseData).then((res) => {
                // setFollowedCompanies((prev) => ({ ...prev, [selectedUserId]: false }));
                setToastMessage(res.data.message);
                setShowToast(true);
                setShowModal(false);
                setCheckFollow(false)
                // Optionally, you can update the userList or searchuserList state if needed
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);


    // -------------------------------------------------------------------------

    const [checkConnect, setCheckConnect ]= useState(isConnectedByYou);
      const [show, setShow] = useState(false);
      const cancelRequestOpen = () => {
        setShow(true);
      };
      const cancelRequestClose = () => {
        setShow(false);
      };
 
      const ConnectUser = async () => {
            const data = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: userUid,
            langKey: language === "en" ? "" : language,
            };

            try {
            const resData = await axios.post("Connection/SendConnectionRequest", data);
            // console.log("isConnect===>", resData);
            setToastMessage(resData?.data?.message);
            setShowToast(true);
            setCheckConnect(true)
            CheckConnectUser(item.userUid);

            setConnectionCheck("Sent");

   

            } catch (error) {
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message || "Something went wrong");
                setShowWarningToast(true);
            } else if (error.response) {
                setErrorToastMessage(error.response.data?.message || "Something went wrong");
                setShowErrorToast(true);
            } else {
                setErrorToastMessage(error.response.data.message || "Network error, please try again");
                setShowErrorToast(true);
            }
            }
        };
  
        const CancelRequest = async () => {
          const data = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: userUid,
            langKey: language === "en" ? "" : language,
          };
      
          try {
            const resData = await axios.post("Connection/CancelConnectionRequest", data);
            console.log("Cancel Connect===>", resData);
            setShowToast(true);
            setToastMessage(resData?.data?.message);
            // setCheckConnect(false)
            setConnectionCheck(null);
            CheckConnectUser(item?.userUid);


            setShow(false);
      
          } catch (e) {
            if (e.response && e.response.status === 404) {
              setWarningToastMessage(e?.response?.data?.message || "Something went wrong");
              setShowWarningToast(true);
            setShow(false);

            } else if (e.response) {
              setErrorToastMessage(e?.response?.data?.message || "Something went wrong");
              setShowErrorToast(true);
              setShow(false);

            }
            else {
              setErrorToastMessage(e?.message  );
              console.log("errorrrr", e?.message);
              
              setShowErrorToast(true);
            }
          }
        };
      



    // -------------------------------------------------------------------------
    
    
    // -------------------------------------------------------------------------
    const { setIsNewsPageLoaded } = useNewsFeedStore();

    useEffect(() => {
        setIsNewsPageLoaded(true); // enable right panel when entering NewsFeed

        return () => setIsNewsPageLoaded(false); // optional cleanup when leaving
    }, [setIsNewsPageLoaded]);

    // -------------------------------------------------------------------------
    //************************Disconnect Request   ************************//
   
 const [showModalDisC, setShowModalDisC] = useState(false);
  const handleShowModalc = ( ) => {  
    setShowModalDisC(true);
  };

  const handleCloseModal = () => {
    setShowModalDisC(false); 
  };
  const DisconnectUser = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: item?.userUid,
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios.post("Connection/DisconnectUser", data).then((resData) => {
        console.log(resData);
        // setShowModalDisC(!showModalDisC);
        //   toast.success(resData.data.message);
        setConnectionId(null);
        setToastMessage(resData.data.message);
        setShowToast(true);
        setConnectionCheck(null);  
        CheckConnectUser(item?.userUid);
        handleCloseModal()
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Disconnect Request ************************//
  //************************Accept Request   ************************//
  const AcceptRequest = async ( ) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID:  item?.userUid,
      // connectID: cnctnId,
      actionType: "Accept",
      langKey: language === "en" ? "" : language,
    };
    console.log('cnctnId', data);

    try {
      await axios
        .post("Connection/ConnectionRequestAction", data)
        .then((resData) => {
          setToastMessage(resData.data.message);
          setShowToast(true);
          
        setConnectionCheck("Connected");  
        CheckConnectUser(item?.userUid);
        //   setRecievedRequest( );
         });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Accept Request ************************//

  //************************Reject Request   ************************//
  const RejectRequest = async (userId, cnctnId) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: userId,
      // connectID: cnctnId,
      actionType: "Reject",
      langKey: language === "en" ? "" : language,
    };
    // console.log(data);
    try {
      await axios
        .post("Connection/ConnectionRequestAction", data)
        .then((resData) => {
          setToastMessage(resData.data.message);
          setShowToast(true);
        //   setRecievedRequest((prev) => prev.filter((item) => item.userUid !== userId));
        //   ReceivedRequestList();
        });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Reject Request ************************//

 const [connectionCheck, setConnectionCheck] = useState(""); 
  
    const [connectionId, setConnectionId] = useState("");
    // api removed from backend
    const CheckConnectUser = async (id) => {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,
        userUID: id,
        langKey: language === "en" ? "" : language,
      };
      try {
        await axios.post("Connection/CheckConnection", data).then((resData) => {
          console.log("checkFollowedUser", resData.data);
          // if (resData.data.status === "Warning") {
            // setConnectionCheck("Connect");
            // } else {
            setConnectionCheck(resData.data.responseData.value);
            setConnectionId(resData.data.responseData.id);
          // }
        });
      } catch (error) {
        console.log(error);
      }
    };
    console.log("checkingggg", connectionCheck);

    useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {  
      // Always check connection for each user (both in regular list and search results)
      if (item?.userUid) {
        CheckConnectUser(item.userUid);
      }
    }
  }, [item?.userUid, searchuserList]);

  const isConnectedCheck = connectionCheck === "Connected";
  const isRequestSent = connectionCheck === "Sent";
  const isRequestReceived = connectionCheck === "Received"; 
  const isNoConnection =
  !connectionCheck || connectionCheck === null;


    return (
        <>
        {/* <div> */}

            {/* <p>{checkFollow === true}followers</p> */}
            {checkFollow === true ? 
            
              <button
                className="wljSecondaryBtn mb-1 wlj-chip-btn"
                 onClick={() => {
                                    handleShowModal(); 
                                }}
            > 
              <PersonRemoveAlt1SharpIcon />
              {t("People.Unfollow")}
            </button>
            : 
            <button
                className="wljPrimaryBtn mb-1 wlj-chip-btn"
                onClick={() => {
                    guestModeData === "true"
                        ? setFollowModal(true)
                        : FollowUser(userUid);
                    // setFollowedId(item?.userUid);
                }}
            > 
              <PersonAddAlt1SharpIcon />
              {t("People.Follow")}
            </button>
            }
  
              {isRequestSent &&  (
                     <button
                                        type="submit"
                                        className="wljSecondaryBtn wlj-chip-btn"
                                        onClick={() => {
                                            cancelRequestOpen();
                                            // setuserUID(item.userUid);
                                        }}
                                        >
                                        <CloseSharpIcon />
                                        {t("Connections.Cancel")}
                                            
                                        </button>
                    )}
                    {isNoConnection &&  (
                       <button
                                        type="submit"
                                        className="wljPrimaryBtn wlj-chip-btn"
                                        // onClick={() => {
                                        //     ConnectUser();
                                        //     // setConnectId(item.userUid);
                                        // }}
                                        onClick={() => {
                    guestModeData === "true"
                        ? setFollowModal(true)
                        : ConnectUser();
                    // setFollowedId(item?.userUid);
                }}
                                        >
                                        <PersonAddAltSharpIcon />
                                        {t("Connections.Connect")}
                                        </button>
                    )}
                    {isRequestReceived &&  (
                       <button
                                        type="submit"
                                        className="wljPrimaryBtn wlj-chip-btn"
                                        onClick={() => {
                                            AcceptRequest();
                                            // setConnectId(item.userUid);
                                        }}
                                        >
                                        <CheckSharpIcon />
                                        {t("Connections.Accept")}
                                        </button>
                    )}
                    {isConnectedCheck &&  (
                       <button
                                        type="submit"
                                        className="wljPrimaryBtn wlj-chip-btn"
                                        onClick={() => {
                                            DisconnectUser();
                                            // setConnectId(item.userUid);
                                        }}
                                        >
                                        <LinkOffSharpIcon />
                                        {t("Connections.Disconnect")}
                                        </button>
                    )}
                    
        {/* </div> */}

        {showModalDisC && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                  {t("modals.Are you sure you want to Disconnect")}
                </h6>
 
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn "
                  onClick={() => DisconnectUser()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
            {showModal && (
                <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>
                                    {t("modals.Are you sure you want to unfollow")}
                                    {/* <b>{selectedItem?.fullName} ?</b> */}
                                </h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleUnfollowCloseModal();
                                    }}
                                />
                            </div>

                            <div className="text-center mt-2">
                                <button
                                    color=""
                                    className="closebtn"
                                    onClick={() => unFollowUser()}
                                >
                                    {t("Recommendations.Unfollow")}  
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )
            }

              {show && (
                    <div
                      className="modal fade show postAdd"
                      tabIndex="-1"
                      role="dialog"
                      style={{ display: "block" }}
                    >
                      <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                          <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                            <h6>{t("modals.Are You Sure You want to Cancel Request?")}</h6>
            
                            <CloseSharpIcon
                              className="material-symbols-sharp me-2 pointer"
                              onClick={() => {
                                cancelRequestClose();
                              }}
                            />
                          </div>
            
                          <div className="text-center mt-2">
                            <button
                              color=""
                              className="closebtn"
                              onClick={() => CancelRequest()}
                            >
                              {t("modals.Yes")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                        {followModal && <ModalForGuest closeModalData={closeModalData} />}

        </>
    )
}

export default PeopleInteraction